import {
  ApplicationConfig,
  provideZoneChangeDetection,
  ErrorHandler,
} from '@angular/core';
import { provideRouter } from '@angular/router';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';
import { providePrimeNG } from 'primeng/config';
import { routes } from './app.routes';
import { provideKeycloakAngular } from './keycloak.config';
import { provideHttpClient, withInterceptors } from '@angular/common/http';
import { authInterceptor } from './interceptors/auth.interceptor';
import { ConfirmationService, MessageService } from 'primeng/api';
import { DatePipe } from '@angular/common';
import { legaleasePreset } from './themePreset';
import { errorInterceptor } from './interceptors/error.interceptor';
import { GlobalErrorHandler } from './interceptors/GlobalErrorHandler';
import { DialogService } from 'primeng/dynamicdialog';
import { LoggerService } from './feature/services/logger.service';
import { BASE_PATH } from '@/generated/legalease-api';
import { environment } from '@/environments/environment';

export const appConfig: ApplicationConfig = {
  providers: [
    LoggerService,
    {
      provide: ErrorHandler,
      useClass: GlobalErrorHandler,
      deps: [LoggerService],
    },
    provideZoneChangeDetection({ eventCoalescing: true }),
    provideRouter(routes),
    provideAnimationsAsync(),
    providePrimeNG({
      theme: {
        preset: legaleasePreset,
      },
    }),
    provideKeycloakAngular(),
    provideHttpClient(withInterceptors([authInterceptor, errorInterceptor])),
    MessageService,
    DatePipe,
    DialogService,
    ConfirmationService,
    { provide: BASE_PATH, useValue: environment.legaleaseApiUrl },
  ],
};
